import ConvenioCreate from './ConvenioCreate'
export {ConvenioCreate}
export default ConvenioCreate
